var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrashGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39844 1.25C4.28125 1.25 4.16406 1.32031 4.09375 1.4375L3.71875 2H7.25781L6.88281 1.4375C6.8125 1.32031 6.69531 1.25 6.57812 1.25H4.39844ZM8.125 2H9.22656H10H10.375C10.5625 2 10.75 2.1875 10.75 2.375C10.75 2.58594 10.5625 2.75 10.375 2.75H9.92969L9.34375 11.1172C9.27344 11.9141 8.64062 12.5 7.84375 12.5H3.13281C2.35938 12.5 1.70312 11.9141 1.63281 11.1172L1.04688 2.75H0.625C0.414062 2.75 0.25 2.58594 0.25 2.375C0.25 2.1875 0.414062 2 0.625 2H1H1.75H2.85156L3.46094 1.03906C3.64844 0.710938 4.02344 0.5 4.39844 0.5H6.57812C6.95312 0.5 7.32812 0.710938 7.53906 1.03906L8.125 2ZM9.17969 2.75H1.79688L2.38281 11.0703C2.40625 11.4453 2.73438 11.75 3.13281 11.75H7.84375C8.24219 11.75 8.57031 11.4453 8.59375 11.0703L9.17969 2.75Z",
    fill: "#4B5080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashGrey);
export default __webpack_public_path__ + "static/media/icon-trash-grey.b0e3994916d327c44b6154a40dd3d11d.svg";
export { ForwardRef as ReactComponent };